import type { MentionNotification as MentionNotificationType } from '@/@types/notification'
import { PostStatus } from '@/@types/post'
import Avatar from '@/components/Avatar'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import ContentContainer from '../ContentContainer'
import ImageGridSection from '../ImageGridSection'
import ScreenName from '../ScreenName'
import styles from './MentionNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface MentionNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: MentionNotificationType
}

export default function MentionNotification({
	data,
	className,
	...props
}: MentionNotificationProps) {
	const {
		actionItem: { users, content, pictures, status },
		referenceItem,
		createdAt,
	} = data
	const isDeleted = status === PostStatus.DELETED
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<Avatar data={users[0]} />

			<div className={styles.content}>
				<header className={styles.header}>
					<div className={styles.headerText}>
						<ScreenName data={users[0]} className={styles.screenName} />
						<span className={styles.secondaryText}>@了你</span>
					</div>
				</header>

				<main className={styles.main}>
					<ContentContainer isDeleted={isDeleted}>
						{content}
						{pictures && <ImageGridSection data={pictures} className={styles.pictureGrid} />}
					</ContentContainer>
				</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
